var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "info"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_1452",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 16,
    height: 16,
    fill: "#959DB1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_1452)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "info_2",
    d: "M7.3335 11.333H8.66683V7.33301H7.3335V11.333ZM8.00016 5.99967C8.18905 5.99967 8.34739 5.93579 8.47516 5.80801C8.60294 5.68023 8.66683 5.5219 8.66683 5.33301C8.66683 5.14412 8.60294 4.98579 8.47516 4.85801C8.34739 4.73023 8.18905 4.66634 8.00016 4.66634C7.81127 4.66634 7.65294 4.73023 7.52516 4.85801C7.39739 4.98579 7.3335 5.14412 7.3335 5.33301C7.3335 5.5219 7.39739 5.68023 7.52516 5.80801C7.65294 5.93579 7.81127 5.99967 8.00016 5.99967ZM8.00016 14.6663C7.07794 14.6663 6.21127 14.4913 5.40016 14.1413C4.58905 13.7913 3.8835 13.3163 3.2835 12.7163C2.6835 12.1163 2.2085 11.4108 1.8585 10.5997C1.5085 9.78856 1.3335 8.9219 1.3335 7.99967C1.3335 7.07745 1.5085 6.21079 1.8585 5.39967C2.2085 4.58856 2.6835 3.88301 3.2835 3.28301C3.8835 2.68301 4.58905 2.20801 5.40016 1.85801C6.21127 1.50801 7.07794 1.33301 8.00016 1.33301C8.92239 1.33301 9.78905 1.50801 10.6002 1.85801C11.4113 2.20801 12.1168 2.68301 12.7168 3.28301C13.3168 3.88301 13.7918 4.58856 14.1418 5.39967C14.4918 6.21079 14.6668 7.07745 14.6668 7.99967C14.6668 8.9219 14.4918 9.78856 14.1418 10.5997C13.7918 11.4108 13.3168 12.1163 12.7168 12.7163C12.1168 13.3163 11.4113 13.7913 10.6002 14.1413C9.78905 14.4913 8.92239 14.6663 8.00016 14.6663Z",
    fill: "#959DB1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfo);
export default __webpack_public_path__ + "static/media/icon_info.9db1865a644a1ac043827ce569b95c54.svg";
export { ForwardRef as ReactComponent };